import React from "react";
import CountUp from "react-countup";
import BgShape from "../Assets/img/funfact-bg-shape.png";
import Icon1 from "../Assets/img/funfact-icon/Certified-teacher.svg";
import Icon2 from "../Assets/img/funfact-icon/Alumni-Students.svg";
import Icon3 from "../Assets/img/funfact-icon/Running-students.svg";
import Icon4 from "../Assets/img/funfact-icon/Achivement-yearly-exam.svg";

const Funfact = () => {
  const CountDownMain = [
    {
      id: "item1",
      singleclass: "funfact-card",
      icon: Icon1,
      countertextclass: "counter-text",
      countertextclass2: "counter-text-2 none",
      number: "20",
      text: "Certified teacher",
    },
    {
      id: "item2",
      singleclass: "funfact-card",
      icon: Icon2,
      countertextclass: "counter-text",
      countertextclass2: "counter-text-2 none",
      number: "5000",
      text: "Satisfied alumni students ",
    },
    {
      id: "item3",
      singleclass: "funfact-card",
      icon: Icon3,
      countertextclass: "counter-text",
      countertextclass2: "counter-text-2 none",
      number: "500",
      text: "Running students",
    },
    {
      id: "item4",
      singleclass: "funfact-card border-none",
      icon: Icon4,
      countertextclass: "counter-text none",
      countertextclass2: "counter-text counter-text-2",
      number: "99",
      text: "Achievement of yearly exam",
    },
  ];

  return (
    <>
      <section
        className="funfact-area"
        style={{ backgroundImage: `url(${BgShape})` }}
      >
        <div className="container">
          <div className="row">
            {CountDownMain.map((SingleCardCount) => (
              <div
                className="col-lg-3 col-md-6 col-12"
                key={SingleCardCount.id}
              >
                <div className={SingleCardCount.singleclass}>
                  <div className="funfact-card-icon">
                    <img src={SingleCardCount.icon} alt="#" />
                  </div>
                  <div className="funfact-content">
                    <h4 className={SingleCardCount.countertextclass}>
                      <span className="counter">
                        <CountUp end={SingleCardCount.number} duration={10} />
                      </span>
                      +
                    </h4>
                    <h4 className={SingleCardCount.countertextclass2}>
                      <span className="counter">
                        <CountUp end={SingleCardCount.number} duration={10} />
                      </span>
                      %
                    </h4>
                    <p className="funfact-cont-text">{SingleCardCount.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Funfact;
